import { ChangeEvent, useCallback } from 'react';

import Box from '../../box/box';
import { Button } from '../../button/button';
import { Icon } from '../../icon';
import BaseIconButton from '../../icon-button/icon-button';
import Menu from '../../menu/menu';
import { styled } from '../../styles/styles';
import TextField from '../../text-field/text-field';
import useFilterState from './use-filter-state';

interface SearchFilterProps {
  initialValue: string;
  label?: string;
  onApplyFilter: (value: string) => void;
  onClearFilter: () => void;
}

const IconButton = styled(BaseIconButton)`
  svg {
    width: 18px;
    height: 18px;
  }
`;

const SearchFilter = ({
  initialValue,
  label,
  onApplyFilter,
  onClearFilter,
}: SearchFilterProps) => {
  const {
    open,
    handleClick,
    value,
    setValue,
    handleClose,
    anchorEl,
    isApplied,
    applyFilter,
    clearFilter,
  } = useFilterState(initialValue, onApplyFilter, onClearFilter);

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.target.value);
    },
    [setValue]
  );

  return (
    <>
      <IconButton
        size="small"
        color={initialValue ? 'primary' : 'inherit'}
        onClick={handleClick}
      >
        <Icon name={'FilterAltOutlined'} />
      </IconButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            applyFilter();
          }}
        >
          <Box display="grid" gridTemplateRows="1fr" rowGap={2}>
            <TextField
              fullWidth
              size="small"
              value={value}
              placeholder={label}
              onChange={onChange}
            />
            <Button variant="contained" fullWidth size="small" type="submit">
              Apply
            </Button>

            {isApplied && (
              <Button
                fullWidth
                size="small"
                variant="outlined"
                onClick={clearFilter}
                type="button"
              >
                Clear
              </Button>
            )}
          </Box>
        </form>
      </Menu>
    </>
  );
};

export default SearchFilter;
